import { useQueryClient } from '@tanstack/react-query'
import { SortingState } from '@tanstack/react-table'
import { UserOrganizationStatus, UserStatus } from '@/constants/user'
import { DlInstance } from '@/lib/axios'
import { useMutation, useQuery } from '@/hooks'
import { datatableSortingStateToQuery } from '@/utils/api'
import { DataResponse, PaginatedResponse } from '@/models/api'
import { SizeStatus } from '@/constants/size'
import axios from 'axios'
import { Bill } from '@/models/bill/bill'
import { Customer } from '@/models/customer/customer'

type UseGetCustomer = {
  page?: number
  pageSize?: number
  sort?: SortingState
  search?: string
  status?: string
  print_status?: string
  payment_method?: string
  payment_status?: string
}

export const useGetCustomerList = ({
  page,
  pageSize,
  sort,
  search,
  status,
  print_status,
  payment_method,
  payment_status,
}: UseGetCustomer) => {
  return useQuery<PaginatedResponse<Customer>>({
    queryKey: [
      'customers',
      { page, pageSize, sort, search, status, print_status, payment_method, payment_status },
    ],
    url: '/customers',
    axiosConfig: {
      params: {
        page,
        pageSize,
        search,
        sort: datatableSortingStateToQuery(sort),
      },
    },
  })
}

export const useGetCustomerNoPage = () => {
  return useQuery<
    DataResponse<
      {
        id: string
        name: string
        phone_number: string
        car_registration: string
      }[]
    >
  >({
    queryKey: ['customers_no_page'],
    url: '/customers/no-page',
  })
}
